export default "__VITE_ASSET__c7ad7ec8__"